export enum SORT_ITEMS_TYPE {
  HYBRID,
  TUBE,
  WAVE
}

export const SORT_ITEMS = [
  {
    id: SORT_ITEMS_TYPE.TUBE,
    title: 'Труба',
  },
  {
    id: SORT_ITEMS_TYPE.WAVE,
    title: 'Волна',
  },
  {
    id: SORT_ITEMS_TYPE.HYBRID,
    title: 'Гибридные',
  },
];

export const LIMIT = 7;